<template>
    <div class="row repeater-row">
        <div class="col-12 col-lg input-education">
            <label class="m-show-lg">Opleiding</label>
            <v-select :options="educations"
                      v-model="education.name"
                      v-if="renderedComponent"
                      :reduce="educations => educations.name"
                      label="name"
                      taggable
                      :selectOnTab="true"
                      @option:created="addEducation"
                      v-validate="'required'"
                      :name="educationNameIndex"
                      :class="{ 'is-invalid': errors.has(educationNameIndex) }"
            >
                <div slot="no-options"></div>
            </v-select>
            <span v-if="errors.first(educationNameIndex)" class="small text-danger">Dit veld is verplicht.</span>
        </div>
        <div class="col-12 col-lg input-education">
            <label class="m-show-lg">Niveau</label>
            <v-select :options="educationsLevel"
                      v-model="education.level"
                      v-if="renderedComponent"
                      label="level"
                      :selectOnTab="true"
                      v-validate="'required'"
                      :name="educationLevelIndex"
                      :class="{ 'is-invalid': errors.has(educationLevelIndex) }"
            >
                <div slot="no-options"></div>
            </v-select>
            <span v-if="errors.first(educationLevelIndex)" class="small text-danger">Dit veld is verplicht.</span>
        </div>
        <div class="col repeat-row-actions">
            <i v-if="educationIndex !== 0 && !editing" class="far fa-trash-alt" @click="removeEducationRow(educationIndex)"></i>
            <i v-if="editing" class="far fa-trash-alt" @click="removeEducationRow(educationIndex)"></i>
        </div>
    </div>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: {
            educations: Array,
            education: Object,
            educationIndex: Number,
            editing: Boolean,
            renderedComponent: Boolean
        },
        data() {
            return {
                educationsLevel: ['VMBO', 'HAVO', 'VWO', 'MBO', 'HBO', 'WO'],
                newEducation: {
                    name: '',
                    default: false,
                }
            }
        },
        methods: {
            addEducation(education) {
                education.default = false;
                education.department = this.$store.getters.getUserData.selectedDepartment;
                this.$store.dispatch('educations/set', education)
            },
            removeEducationRow(educationIndex) {
                this.$emit('educationRemoved', educationIndex)
            },
        },
        computed: {
            educationNameIndex() {
                return 'educationName-' + this.educationIndex;
            },
            educationLevelIndex() {
                return 'educationLevel-' + this.educationIndex;
            },
        }
    }
</script>